module.exports = __webpack_public_path__ + "img/ico_menual07_on.c7b75aea.svg";